module.exports = __webpack_public_path__ + "img/bow_tapered_angle.73872a7b.png";